import { RouterStateSnapshot, convertToParamMap } from '@angular/router';

import { ActionReducerMap } from '@ngrx/store';
import { RouterStateSerializer, routerReducer } from '@ngrx/router-store';

import { RouterState, RouterStateUrl } from './router.state';

export const routerFeatureKey = 'router';

export const reducers: ActionReducerMap<RouterState> = {
  router: routerReducer,
};

export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const { url } = routerState;
    const { paramMap } = route;
    const { queryParams } = route;
    const queryParamsMap = convertToParamMap(queryParams);

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, paramMap, queryParamsMap };
  }
}
